/**
 * Quick add panel toggle.
 *
 * The add-to-cart forms post natively, so this file only opens and closes the
 * variant list. With JavaScript off, single-variant products still add to cart
 * and multi-variant products simply show no panel.
 */
(() => {
  const closeAll = (except) => {
    document.querySelectorAll('[data-mdc-quick-add-panel]').forEach((panel) => {
      if (panel === except) return;
      panel.hidden = true;
      panel.previousElementSibling?.setAttribute('aria-expanded', 'false');
    });
  };

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-mdc-quick-add-toggle]');

    if (!toggle) {
      if (!event.target.closest('[data-mdc-quick-add-panel]')) closeAll();
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    const panel = toggle.parentElement.querySelector('[data-mdc-quick-add-panel]');
    if (!panel) return;

    const open = panel.hidden;
    closeAll(panel);
    panel.hidden = !open;
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeAll();
  });
})();
